import config from '@/data/config';

import { backoffice as backofficeAPI } from '@/services';

const STORAGE_KEY = 'reloadedForVersion';
const MIN_INTERVAL_MS = 5 * 60 * 60 * 1000; // check interval

let lastCheckedAt = 0;
let inflight = null;

async function runValidation() {
  try {
    const { data } = await backofficeAPI.getAPPVersion(Date.now());

    const deployVersion = String(data?.data?.version ?? '');
    const localVersion = String(config?.DEPLOY_VERSION ?? '');
    const reloadedForVersion = localStorage.getItem(STORAGE_KEY);

    if (!deployVersion || !localVersion) {
      return { scheduled: false };
    }

    if (deployVersion === localVersion) {
      localStorage.removeItem(STORAGE_KEY);
      return { scheduled: false };
    }

    if (reloadedForVersion === deployVersion) {
      return { scheduled: false };
    }

    localStorage.setItem(STORAGE_KEY, deployVersion);

    return { scheduled: true };
  } catch {
    return { scheduled: false };
  }
}

export function useAppVersion() {
  async function validateAppVersion({ force = false } = {}) {
    // dedupe concurrent calls
    if (inflight) return inflight;

    // skip if a recent check already happened
    if (!force && Date.now() - lastCheckedAt < MIN_INTERVAL_MS) {
      return { scheduled: false };
    }

    inflight = runValidation().finally(() => {
      lastCheckedAt = Date.now();
      inflight = null;
    });

    return inflight;
  }

  function clearVersionGuard() {
    localStorage.removeItem(STORAGE_KEY);
  }

  return { validateAppVersion, clearVersionGuard };
}
